export default "__VITE_ASSET__2CoSwACG__"